import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card mb-12" }
const _hoisted_3 = { class: "card-header flex-column flex-nowrap justify-content-around pb-4 pt-6 px-3 mx-6" }
const _hoisted_4 = { class: "card-title m-0 py-3" }
const _hoisted_5 = { class: "fw-bolder m-0" }
const _hoisted_6 = { class: "px-9 pb-6 pt-4" }
const _hoisted_7 = { class: "row py-6 gy-lg-7 gy-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Order Type", -1)
const _hoisted_9 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Customer Name", -1)
const _hoisted_11 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Store Name", -1)
const _hoisted_13 = { class: "col-lg-7 d-flex justify-content-between" }
const _hoisted_14 = { class: "fw-bolder fs-5 text-dark" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("View Store")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Car Description", -1)
const _hoisted_17 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Pickup Location", -1)
const _hoisted_19 = { class: "col-lg-7 d-flex justify-content-between" }
const _hoisted_20 = { class: "fw-bolder fs-5 text-dark" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Show Map")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Date Order", -1)
const _hoisted_23 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Date Service Start", -1)
const _hoisted_25 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Date Service End", -1)
const _hoisted_27 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Price (TH)", -1)
const _hoisted_29 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Pay Method", -1)
const _hoisted_31 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Pay Status", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, " Order ID: " + _toDisplayString(_ctx.orderData.id.slice(16).toUpperCase()), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, _toDisplayString($setup.packageName), 1),
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.orderData.customer?.name || '-'), 1),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.orderData.store?.name || '-'), 1),
                (_ctx.orderData.store)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/stores/${_ctx.orderData.store?.id || _ctx.orderData.store}`,
                      class: "fw-bolder fs-5 text-primary me-lg-8"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_16,
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.orderData.car?.name || '-'), 1),
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.orderData.servicePoint?.name || '-'), 1),
                (_ctx.orderData.servicePoint?.id)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/location/node/${_ctx.orderData.servicePoint?.id}`,
                      class: "fw-bolder fs-5 text-primary me-lg-8"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_22,
              _createElementVNode("span", _hoisted_23, _toDisplayString($setup.dateFormat(_ctx.orderData.createdAt)), 1),
              _hoisted_24,
              _createElementVNode("span", _hoisted_25, _toDisplayString($setup.dateFormat(_ctx.orderData.startDate)), 1),
              _hoisted_26,
              _createElementVNode("span", _hoisted_27, _toDisplayString($setup.dateFormat(_ctx.orderData.endDate)), 1),
              _hoisted_28,
              _createElementVNode("span", _hoisted_29, _toDisplayString($setup.numberFormat(_ctx.orderData.amountPrice)), 1),
              _hoisted_30,
              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.orderData.payment?.method || '-'), 1),
              _hoisted_32,
              _createElementVNode("span", {
                class: _normalizeClass([_ctx.orderData.status == 'Done' ? 'text-success' : '', "col-lg-7 fw-bolder fs-5"])
              }, _toDisplayString($setup.mappedStatus[_ctx.orderData.status]), 3)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}